import React, { useState } from "react";
import { Cell, Pie, PieChart, Sector } from "recharts";
import styled from "styled-components";
import { MACROS_GROUP_BY_CAT } from "../common/constant";
import { prettyCount } from "../../../utils/format";

const AnalyticsTile = styled.div`
  background-color: #F7F8FA;
  width: 260px;
  // height: 162px;
  border-radius: 10px;
  margin: 15px 12px 15px 0px;
  text-align: center;
  display: inline-block;
  color: #313131;
`;

const Title = styled.div`
  margin-top: 18px;
  font-size: 12px;
  font-weight: 700;
  font-style: bold;
  opacity: 0.99;
`;

const MetricWrapper = styled.div`
  margin-top: 32px;
  margin-bottom:32px;
`;

const GenderWrapper = styled.div`
  margin-bottom:18px;
  background-color: #FFFFFF;
  border-radius: 100px;
  font-size: 12px;
  display: inline-block;
  padding: 2px 5px;
  display:none;
`;

const Metric = styled.span`
  font-weight: 700;
  font-size: 28px;
  margin-right: 5px;
  position:relative;
  margin-left: 5px;
  top:-5px;
`;

const TileInfo = styled.div`
  font-size: 10px;
  color: #313131;
  padding-top: 10px;
`;

const CircleDot = styled.span<{ $backgroundColor?: string }>`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  background-color: ${props => props.$backgroundColor || 'transparent'};
`;

type SearchAnalyticsProps = {
  data: any,
  type: string,
  title: string,
  deiDisabled: boolean
}

const renderActiveShape = (props:any) => {
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
    fill, payload, percent, value } = props;

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 3}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

const percentile = (count: number = 0, total: number = 1) => {
  return (Math.floor((count*100)/total));
}

const CountText = styled.span`
  position: relative;
  top: -7px;
`;

const LegendDot = styled(CircleDot)<{ $marginLeft?: string }>`
  margin-left: ${props => props.$marginLeft || '0'};
`;

const PieChartWrapper = styled.div`
  display: inline-block;
`;

const SearchAnalytics = (props: SearchAnalyticsProps) => {
  const { data, type, title, deiDisabled } = props;
  const [macros] = useState(MACROS_GROUP_BY_CAT[type]) as any;

  return (
    <>
      <TileInfo>
        <LegendDot $backgroundColor="#C1DDFD" /> Total Matches ({prettyCount(data['base_filter_count'])})
        <LegendDot $backgroundColor="#75B2FF" $marginLeft="10px" />{title}
      </TileInfo>
      {Object.keys(macros).map((macro_id: string) => (
        <AnalyticsTile key={macro_id}>
          <Title>{macros[macro_id]}</Title>
          <MetricWrapper>
            <PieChartWrapper>
              <PieChart width={30} height={30}>
                <Pie
                  activeIndex={0}
                  data={[
                    { name: 'A', value: percentile(data['count_by_queries'][macro_id], data['base_filter_count']) },
                    { name: 'B', value: 100 - percentile(data['count_by_queries'][macro_id], data['base_filter_count']) }
                  ]}
                  cx="50%"
                  cy="50%"
                  outerRadius={12}
                  dataKey="value"
                  stroke=""
                  activeShape={renderActiveShape}
                >
                  <Cell key={`cell-${type}-1`} fill="#75B2FF" />
                  <Cell key={`cell-${type}-2`} fill="#C1DDFD" />
                </Pie>
              </PieChart>
            </PieChartWrapper>
            <Metric>{percentile(data['count_by_queries'][macro_id], data['base_filter_count'])}%</Metric>
            <CountText>({prettyCount(data['count_by_queries'][macro_id] || 0)})</CountText>
          </MetricWrapper>
          {!deiDisabled && (
            <GenderWrapper>
            <span>XYZ Women | XYZ Men | </span><span style={{fontWeight: 700}}>Gender Gap</span>
          </GenderWrapper>
          )}
        </AnalyticsTile>
      ))}
    </>
  );
}

export default SearchAnalytics;